var React = require('react');

function Done (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoDone"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoDone","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("polygon",{"fill":"#FFFFFF","points":"6.872 13.324 16.133 4 17.372 5.239 6.872 15.739 2 10.867 3.176 9.628"}))]);
}

Done.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Done;

Done.default = Done;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/done.svg
// module id = 931
// module chunks = 0